import { Project } from "./project";
import { Identifiable } from "./identifiable";
import { id } from "./id";

type Planzone = {
  uuid: string;
  code: string;
  name: string;
  domain: string;
  organization: string;
  projects: Identifiable<Project>[];
  settings: { [key: string]: string };
  attributes: { [key: string]: string };
  data: { [key: string]: string };
  timesheetDeadline: string | null;
  criticalDailyAmplitudeHours: number | null;
  criticalDailyVolumeHours: number | null;
  criticalRestPeriodHours: number | null;
};

const planzone: Planzone = {
  uuid: id,
  code: "",
  name: "",
  domain: "",
  organization: "",
  projects: [],
  settings: {},
  attributes: {},
  data: {},
  timesheetDeadline: null,
  criticalDailyAmplitudeHours: null,
  criticalDailyVolumeHours: null,
  criticalRestPeriodHours: null,
};

export type { Planzone };

export { planzone };
